"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _AppState = _interopRequireDefault(require("composer-lib/data/model/AppState"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _AppState.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.SET_EDITOR_LOADED:
      return state.set('loaded', true);

    case _ActionTypes.default.SET_BODY_EDITOR_ACTIVE:
      return state.set('bodyActive', action.data);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;